import React, { useMemo } from 'react';
import {
  DialogContent,
  FormControlLabel,
  Checkbox,
  makeStyles
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { DateTime } from 'luxon';
import { DateField } from '~/modules/common/components';
import { toRepliconDate } from '~/modules/common/dates/convert';
import ClearAllocationCheckboxTooltip from './components/ClearAllocationCheckboxTooltip';

const useStyles = makeStyles(theme => ({
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    columnGap: theme.spacing(1)
  },
  checkboxLabel: {
    margin: theme.spacing(0)
  },
  dateFieldContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

const SetResourceAllocationDialogContent = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const clearAllocationCheckbox = useMemo(
    () => (
      <Checkbox
        checked={false} // TODO
        color="primary"
        onChange={() => {}} // TODO
      />
    ),
    []
  );

  return (
    <DialogContent className={classes.root}>
      <div className={classes.dateFieldContainer}>
        <DateField
          ariaLabel={formatMessage({
            id: 'setResourceAllocationDialog.startDate'
          })}
          clearable={false}
          dataQeId="SetResourceAllocationDialog_StartDate"
          editable
          fullWidth
          onChange={() => {}} // TODO
          label={formatMessage({
            id: 'setResourceAllocationDialog.startDate'
          })}
          value={toRepliconDate(DateTime.now())} // TODO
          variant="filled"
          useV5DatePicker
        />
        <DateField
          ariaLabel={formatMessage({
            id: 'setResourceAllocationDialog.endDate'
          })}
          clearable={false}
          dataQeId="SetResourceAllocationDialog_EndDate"
          editable
          fullWidth
          label={formatMessage({
            id: 'setResourceAllocationDialog.endDate'
          })}
          onChange={() => {}} // TODO
          value={toRepliconDate(DateTime.now())} // TODO
          variant="filled"
          useV5DatePicker
        />
      </div>
      <div className={classes.checkboxContainer}>
        <FormControlLabel
          className={classes.checkboxLabel}
          control={clearAllocationCheckbox}
          label={formatMessage({
            id: 'setResourceAllocationDialog.clearAllocationCheckboxLabel'
          })}
        />
        <ClearAllocationCheckboxTooltip />
      </div>
    </DialogContent>
  );
};

export default SetResourceAllocationDialogContent;
